module.exports = __webpack_public_path__ + "static/img/brown_p.5676dc2d.png";